export * from './space.component';

import {Menu} from './menu';
import {TopBarComponent} from './top_bar';

export const SPACE_COMPONENTS = [
    Menu,
    TopBarComponent
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/space/index.ts